"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoundedDurationByDigit = void 0;
const moment_1 = __importDefault(require("moment"));
const helpers_1 = require("./..");
const getRoundedDurationByDigit = (duration, maxItems) => {
    if (!maxItems || maxItems > 3) {
        return duration;
    }
    const config = [duration.days(), duration.hours(), duration.minutes(), duration.seconds()];
    const biggestItemIndex = config.findIndex((value) => !!value);
    const droppedItemIndex = biggestItemIndex + maxItems;
    if (droppedItemIndex > config.length - 1) {
        return duration;
    }
    const roundValuesMap = [0, 12, 30, 30]; // 1 day 12 hours -> 2 days, 1 hour 30 min -> 2 hours, 1 min 30 sec -> 2 min
    config[droppedItemIndex - 1] = Number(helpers_1.roundToBiggerUnit(config[droppedItemIndex], config[droppedItemIndex - 1], roundValuesMap[droppedItemIndex]));
    // drop values after rounded
    for (let index = droppedItemIndex; index < config.length; index++) {
        config[index] = 0;
    }
    return moment_1.default.duration({
        days: config[0],
        hours: config[1],
        minutes: config[2],
        seconds: config[3],
    });
};
exports.getRoundedDurationByDigit = getRoundedDurationByDigit;
//# sourceMappingURL=getRoundedDurationByDigit.js.map